import { Button, Divider, Flex, Icon, IconButton, Menu, MenuButton, MenuItem, MenuList, Stack, Text } from '@chakra-ui/react';
import { FiMoreVertical } from 'react-icons/fi';
import { RiArrowRightLine } from 'react-icons/ri';

import { ButtonGroup } from './styles';

type ControlsData = {
	page: number;
	perPage: number;
	totalPage: number;
};
type ClassificacaoData = {
	id: number;
	id_sub: number;
	nome: string;
	prod_visible: boolean;
	status: string;
}
type ProdutoData = {
  id: string;
  categoria: string;
  cod_barras: string;
  complementos: string;
  descricao: string;
  nome: string;
  promocao: string;
  qtd: number;
  status: string;
  url_imagem: string;
  id_classif: number;
	valor: number;
	total: number;
	valorFormatted: string;
	totalFormatted: string;
};
interface DataTableCardsParams {
  produtos: ProdutoData[];
	setClassifModal: (classif: ClassificacaoData) => void;
	setProdutoModal: (product: ProdutoData) => void;
	setModalPausarAtivarVisible: (visible: boolean) => void;
	setModalProdutoVisible: (visible: boolean) => void;
	handleFindClassif: (classif: string) => void;
}

const DataTableCards: React.FC<DataTableCardsParams> = ({
	produtos,
	setClassifModal,
	setProdutoModal,
	setModalPausarAtivarVisible,
	setModalProdutoVisible,
	handleFindClassif,
}) => {
  return (
    <Flex w="100%" flexDir="column" justify="center" align="center">
      {produtos.map(produto => {
        return (
          <Flex
            key={produto.id}
            // justify="space-between"
            w="100%"
            bgGradient="linear(to-r, gray.50, gray.100)"
            borderRadius={8}
            boxShadow="xl"
            p="4"
						pr="2"
						m={["2", "4"]}
          >
						<Flex w="100%">
							<Stack w="100%" spacing={1}>
                {produto.nome && (
                  <Flex flexDir="column">
										<Text
											color="blue.500"
											textTransform="uppercase"
											fontWeight="500"
											fontSize="14"
										>
											{produto.nome}
										</Text>
										<Text
											color="gray.500"
											textTransform="uppercase"
											fontWeight="500"
											fontSize="sm"
										>
											{produto.categoria} - {produto.cod_barras}
										</Text>
                  </Flex>
                )}

								<Flex w="100%" justify="space-between">
									{produto.valor && (
										<Flex flexDir="column">
											<Text color="gray.600" fontSize={["12", "14"]} fontWeight="500">
												Valor: {produto.valorFormatted}
											</Text>
											<Text color="gray.600" fontSize={["12", "14"]} fontWeight="500">
												Total: {produto.totalFormatted}
											</Text>
										</Flex>
									)}

									<Flex>
										<ButtonGroup status={produto.status === 'S' ? true : false}>
											<button
												className="btn-desativar"
												onClick={() => {
													setClassifModal({} as ClassificacaoData);
													setProdutoModal(produto);
													setModalPausarAtivarVisible(true);
												}}
												disabled={produto.status === 'N'}
											>
												{produto.status === 'N' ? 'Pausado' : 'Pausar'}
											</button>

											<button
												className="btn-ativar"
												onClick={() => {
													setClassifModal({} as ClassificacaoData);
													setProdutoModal(produto);
													setModalPausarAtivarVisible(true);
												}}
												disabled={produto.status === 'S'}
											>
												{produto.status === 'S' ? 'Ativo' : 'Ativar'}
											</button>
										</ButtonGroup>

										<Menu isLazy>
											{({ isOpen }) => (
												<>
													<MenuButton
														as={IconButton}
														fontSize={["1.6rem", "2rem"]}
														isActive={isOpen}
														icon={<FiMoreVertical />}
														_hover={{	bg: 'gray.50' }}
														_expanded={{ bg: 'gray.100' }}
														css={{ '-webkit-tap-highlight-color': 'transparent' }}
													/>

													<MenuList p={0} boxShadow='xl'>
														<MenuItem
															fontSize={16}
															fontWeight={500}
															py={3}
															_hover={{ bg: 'gray.50' }}
															onClick={() => {
																handleFindClassif(produto.categoria);
																// setClassifModal(classif);
																setProdutoModal(produto);
																setModalProdutoVisible(true);
															}}
														>
															Editar
														</MenuItem>

														<Divider />

														<MenuItem
															fontSize={16}
															fontWeight={500}
															py={3}
															_hover={{ bg: 'gray.50' }}
															isDisabled={true}
														>
															Excluir
														</MenuItem>

														<Divider />

														<MenuItem
															fontSize={16}
															fontWeight={500}
															py={3}
															_hover={{ bg: 'gray.50' }}
															isDisabled={true}
														>
															Duplicar
														</MenuItem>
													</MenuList>
												</>
											)}
										</Menu>
									</Flex>
								</Flex>
              </Stack>
            </Flex>

            {/* <Flex flexDir="column" justify="end" >
							<Flex align="center">
								<ButtonGroup status={produto.status === 'S' ? true : false}>
									<button
										className="btn-desativar"
										onClick={() => {
											setClassifModal({} as ClassificacaoData);
											setProdutoModal(produto);
											setModalPausarAtivarVisible(true);
										}}
										disabled={produto.status === 'N'}
									>
										{produto.status === 'N' ? 'Pausado' : 'Pausar'}
									</button>

									<button
										className="btn-ativar"
										onClick={() => {
											setClassifModal({} as ClassificacaoData);
											setProdutoModal(produto);
											setModalPausarAtivarVisible(true);
										}}
										disabled={produto.status === 'S'}
									>
										{produto.status === 'S' ? 'Ativo' : 'Ativar'}
									</button>
								</ButtonGroup>
								
								<Menu isLazy>
									{({ isOpen }) => (
										<>
											<MenuButton
												as={IconButton}
												fontSize={["1.6rem", "2rem"]}
												isActive={isOpen}
												icon={<FiMoreVertical />}
												px="-5px !important"
												_hover={{
													bg: 'gray.50'
												}}
												_expanded={{
													bg: 'gray.100',
												}}
												_focus={{
													bg: 'transparent'
												}}
											/>

											<MenuList p={0} boxShadow='xl'>
												<MenuItem
													fontSize={16}
													fontWeight={500}
													py={3}
													_hover={{ bg: 'gray.50' }}
													onClick={() => {
														handleFindClassif(produto.categoria);
														// setClassifModal(classif);
														setProdutoModal(produto);
														setModalProdutoVisible(true);
													}}
												>
													Editar
												</MenuItem>

												<Divider />

												<MenuItem
													fontSize={16}
													fontWeight={500}
													py={3}
													_hover={{ bg: 'gray.50' }}
													isDisabled={true}
												>
													Excluir
												</MenuItem>

												<Divider />

												<MenuItem
													fontSize={16}
													fontWeight={500}
													py={3}
													_hover={{ bg: 'gray.50' }}
													isDisabled={true}
												>
													Duplicar
												</MenuItem>
											</MenuList>
										</>
									)}
								</Menu>
							</Flex>
            </Flex> */}
          </Flex>
        );
      })}
    </Flex>
  );
};

export default DataTableCards;
